import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ConciergePage from "./pages/ConciergePage";
import EventsPage from "./pages/EventsPage";
import BrandyCeremonyPage from "./pages/BrandyCeremonyPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/concierge" element={<ConciergePage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/brandy-ceremony-2026" element={<BrandyCeremonyPage />} />
          {/* Catch-all redirect to homepage — prevents 404s for crawled URLs */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
